import React, { useRef } from 'react';
import { formatSecondsShort } from '../../utils/audio-segments';
import {
  MARKER_COLORS,
  MARKER_LABELS,
  VideoMoment,
} from '../../utils/video-moments.utils';
import styles from './video-analytics.module.scss';

type Props = {
  moments: VideoMoment[];
  getThumbUrl?: (slideIndex: number) => string | null;
  onSeek: (seconds: number) => void;
};

const MomentCards: React.FC<Props> = ({ moments, getThumbUrl, onSeek }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  if (!moments.length) {
    return (
      <div className={styles.momentCardsEmpty}>
        Ключевые моменты появятся после AI-аналитики (решения, KPI, споры).
      </div>
    );
  }

  return (
    <div className={styles.momentCardsSection}>
      <div className={styles.momentCardsHeader}>
        <span className={styles.momentCardsTitle}>Активность и ключевые моменты</span>
        <span className={styles.momentCardsMeta}>{moments.length} событий</span>
      </div>
      <div className={styles.momentCardsTrack} ref={scrollRef}>
        {moments.map((m, i) => {
          const thumb = m.slideIndex != null ? getThumbUrl?.(m.slideIndex) : null;
          return (
            <button
              key={`${m.seconds}-${m.type}-${i}`}
              type="button"
              className={styles.momentCard}
              style={{ borderTopColor: MARKER_COLORS[m.type] }}
              onClick={() => onSeek(m.seconds)}
              title={m.label}
            >
              <div className={styles.momentCardThumb}>
                {thumb ? (
                  <img src={thumb} alt="" onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
                ) : (
                  <span className={styles.momentCardThumbPlaceholder}>
                    {MARKER_LABELS[m.type].slice(0, 3).toUpperCase()}
                  </span>
                )}
              </div>
              <div className={styles.momentCardBody}>
                <span className={styles.momentCardTime}>{formatSecondsShort(m.seconds)}</span>
                <span
                  className={styles.momentCardTag}
                  style={{ color: MARKER_COLORS[m.type] }}
                >
                  {MARKER_LABELS[m.type]}
                </span>
                <p className={styles.momentCardText}>{m.label}</p>
                {m.speaker && (
                  <span className={styles.momentCardSpeaker}>{m.speaker}</span>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MomentCards;
